module.exports = angular.module('cartographer.common.duration', [])

$ = require 'jquery'

module.exports.factory 'crtDuration', $DI (crtString) ->
  format = (duration) ->
    hours   = Math.floor(duration / 60)
    minutes = Math.floor(duration % 60)
    "#{hours}:#{crtString.addLeadingZeroes(minutes, 2)}"

  parse = (text) ->
    match = $.trim(text).match(/^(\d*)([:.](\d*))?$/)
    if match
      hh = crtString.addLeadingZeroes(match[1] ? "", 1)
      mm = crtString.addLeadingZeroes(match[3] ? "", 1)
      (60 * parseInt(hh, 10)) + ( 1 * parseInt(mm, 10))
    else null

  return {
    format
    parse
  }
